module.exports = __webpack_public_path__ + "static/media/scroll3_2.9ac2296f.png";